import { Injectable } from '@angular/core'
import { Logger } from '../../../logger.service'
import { ApiService } from '../../general/api.service'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { Planner } from '../../../models'
import { HttpParams } from '@angular/common/http'
import { LocalStorageService } from '../../../helper'

const log = new Logger('PlannerService')

/**
 * Đây là services dành cho Planner
 */

@Injectable({ providedIn: 'root' })
export class PlannerService {
  constructor(
    private apiService: ApiService,
    private storage: LocalStorageService
  ) {}
  /**
   * Khai báo tất cả các path sẻ sử dụng cho User
   */
  private _apiPath = {
    list: 'manager/planner_entity',
    detail: 'manager/planner_entity',
  }

  getAll(params?: any): Observable<any> {
    // let pa = new HttpParams();
    let pa = new HttpParams().set(
      'parameters[planner_business_id]',
      this.storage.getActiveLocalBusinessID()
    )
    if (params) {
      Object.keys(params).forEach(function(key) {
        pa = pa.append(key, params[key])
      })
    }
    return this.apiService.get<any>(this._apiPath.list, pa).pipe(
      map(data => {
        log.debug(data)
        return data
      })
    )
  }

  create(res): Observable<any> {
    res.pid = null
    return this.apiService.post(this._apiPath.detail, res).pipe(
      map(data => {
        log.debug(data)
        return data
      })
    )
  }

  getDetail(id: string): Observable<any> {
    return this.apiService.get<any>(`${this._apiPath.detail}/${id}`).pipe(
      map(data => {
        log.debug(data)
        return data
      })
    )
  }

  delete(pid): Observable<any> {
    return this.apiService.delete(`${this._apiPath.detail}/${pid}`).pipe(
      map(data => {
        log.debug(data)
        return data
      })
    )
  }
}
